import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PreLoader from "components/preloader/Preloader";
import DashboardLayout from "components/DashboardLayout";
import { useAppConfig } from "hooks/useAppConfig";
const Home = lazy(() => import("pages/Home"));
const Login = lazy(() => import("pages/Login"));
const Signup = lazy(() => import("pages/Signup"));
const SubmitJob = lazy(() => import("pages/SubmitJob"));
const MyJobs = lazy(() => import("pages/MyJobs"));
const Jobs = lazy(() => import("pages/Jobs"));
const JobDescription = lazy(() => import("pages/JobDescription"));
const Dashboard = lazy(() => import("pages/Dashboard"));
const SavedJobs = lazy(() => import("pages/SavedJobs"));
const MyProfile = lazy(() => import("pages/MyProfile"));
const MyJobEdit = lazy(() => import("pages/MyJobEdit"));
const Applicants = lazy(() => import("pages/Applicants"));
const Pricing = lazy(() => import("../pages/Pricing"));
const Success = lazy(() => import("../pages/Success"));
const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const ResetPassword = lazy(() => import("pages/ResetPassword"));
const Contact = lazy(() => import("pages/Contact"));
const FAQ = lazy(() => import("pages/FAQ"));
const CVServices = lazy(() => import("pages/CVServices"));
const CVServicesSuccess = lazy(() => import("pages/CVServicesSuccess"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("pages/TermsOfUse"));
const VerifyEmail = lazy(() => import("pages/VerifyEmail"));
const MyApplications = lazy(() => import("pages/MyApplications"));

const Config = () => {
  useAppConfig();

  return (
    <Router>
      <Suspense fallback={<PreLoader />}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/signup" element={<Signup />}></Route>
          <Route path="/forgot-password" element={<ForgotPassword />}></Route>
          <Route path="/reset-password" element={<ResetPassword />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/faq" element={<FAQ />}></Route>
          <Route path="/cv-services" element={<CVServices />}></Route>
          <Route path="/cv-services/success" element={<CVServicesSuccess />}></Route>
          <Route path="/cv-services/:token" element={<CVServices />}></Route>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/terms-of-use" element={<TermsOfUse />}></Route>
          <Route path="/verify-email" element={<VerifyEmail />}></Route>
          <Route path="/jobs" element={<Jobs />}></Route>
          {/* till here the new ui is ready */}
          <Route path="/jobs-description/:jobId" element={<JobDescription />}></Route>
          {/* dashboard */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route path="submit-job" element={<SubmitJob />} />
            <Route path="jobs" element={<MyJobs />} />
            <Route path="job/:jobId" element={<MyJobEdit />} />
            <Route path="home" element={<Dashboard />} />
            <Route path="saved-jobs" element={<SavedJobs />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="my-applications" element={<MyApplications />} />
            {/* <Route path="favourite-jobs" element={<FavouriteJobs />} /> */}
            <Route path="applicants/:jobId" element={<Applicants />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="success" element={<Success />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};

export default Config;
